import React from "react";
import { useTranslation } from "react-i18next";
import Recommendations from "./Screens/Recommendations";
import MakeupDay from "./Screens/MakeupDay";
import CustomDate from "./Screens/CustomDate";
import RescheduleReview from "./Screens/RescheduleReview";
import Container from "./Components/Container";
import TitleSection from "./Components/TitleSection";
import NoAppointmentsImage from "../../assets/no_appointments.png";
import RescheduleWindowClosedImage from "../../assets/reschedule_window.png";
import AppointmentRemovedImage from "../../assets/appointment_removed.png";
import SomethingWentWrongImage from "../../assets/something_went_wrong.png";
import RescheduleCompleteImage from "../../assets/reschedule_complete.png";
import { GoHomePrimary, STEPS } from "./utils";
import CancelAppointment from "./Screens/CancelAppointment";
import EventSummary from "./Components/EventSummary";
import { LoadingScreen } from "components/EventScheduling/EventSchedulingUtils";
import { useRescheduling } from "./ReschedulingProvider";
import { Button } from "@mui/material";
import { ArrowsClockwise } from "@phosphor-icons/react";

export default function FlowManager() {
  const { t } = useTranslation(["rescheduling"]);
  const { currentStep, rescheduleOptionsLoading, rescheduling12hrWindowPilot } = useRescheduling();

  if (rescheduleOptionsLoading || !currentStep) return <LoadingScreen />;

  if (currentStep === STEPS.appointmentRemoved) {
    return (
      <Container>
        <TitleSection
          imageSrc={AppointmentRemovedImage}
          title={t("rescheduling:flowManager.appointmentRemoved.title")}
          subtitle={t("rescheduling:flowManager.appointmentRemoved.subtitle")}
        />
        <Button
          variant="contained"
          color="primary"
          startIcon={<ArrowsClockwise />}
          onClick={() => window.location.reload()}
        >
          {t("rescheduling:common.tryAgain")}
        </Button>
      </Container>
    );
  }
  if (currentStep === STEPS.somethingWentWrong) {
    return (
      <Container>
        <TitleSection
          imageSrc={SomethingWentWrongImage}
          title={t("rescheduling:flowManager.somethingWentWrong.title")}
          subtitle={t("rescheduling:flowManager.somethingWentWrong.subtitle")}
        />
        <Button
          variant="contained"
          color="primary"
          startIcon={<ArrowsClockwise />}
          onClick={() => window.location.reload()}
        >
          {t("rescheduling:common.tryAgain")}
        </Button>
      </Container>
    );
  }

  if (currentStep === STEPS.rescheduleWindowClosed) {
    return (
      <Container>
        <TitleSection
          imageSrc={RescheduleWindowClosedImage}
          title={t("rescheduling:flowManager.windowClosed.title")}
          subtitle={t("rescheduling:flowManager.windowClosed.subtitle", {
            hours: rescheduling12hrWindowPilot ? 12 : 24,
          })}
        />
        <GoHomePrimary />
      </Container>
    );
  }

  if (currentStep === STEPS.noAppointments) {
    return (
      <Container>
        <TitleSection
          imageSrc={NoAppointmentsImage}
          title={t("rescheduling:flowManager.noAppointments.title")}
          subtitle={t("rescheduling:flowManager.noAppointments.subtitle")}
        />
        <GoHomePrimary />
      </Container>
    );
  }

  if (currentStep === STEPS.supervisorUnavailable) {
    return (
      <Container>
        <TitleSection
          imageSrc={NoAppointmentsImage}
          title="No appointment times available."
          subtitle="Your appointment requires a supervisory clinician, and we couldn't find a time that works for everyone. Text your BCBA and they’ll help you coordinate a new time."
        />
        <GoHomePrimary />
      </Container>
    );
  }

  if (currentStep === STEPS.recommendations) return <Recommendations />;
  if (currentStep === STEPS.customDate) return <CustomDate />;
  if (currentStep === STEPS.review) return <RescheduleReview />;
  if (currentStep === STEPS.cancellationReview) return <CancelAppointment />;
  if (currentStep === STEPS.rescheduleConfirmation) {
    return (
      <Container>
        <TitleSection
          imageSrc={RescheduleCompleteImage}
          title={t("rescheduling:flowManager.rescheduleConfirmation.title")}
          subtitle={t("rescheduling:flowManager.rescheduleConfirmation.subtitle")}
        />
        <EventSummary highlightText={t("rescheduling:newAppointmentTime")} />
        <GoHomePrimary />
      </Container>
    );
  }
  if (currentStep === STEPS.cancellationConfirmation) {
    return (
      <Container>
        <TitleSection
          title={t("rescheduling:flowManager.cancellationConfirmation.title")}
          subtitle={t("rescheduling:flowManager.cancellationConfirmation.subtitle")}
        />
        <GoHomePrimary />
      </Container>
    );
  }
  return <MakeupDay />;
}
